
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Patient } from '@/types/doctor';
import PatientPersonalInfo from './PatientPersonalInfo';
import PatientMedicalInfo from './PatientMedicalInfo';
import PatientAppointments from './PatientAppointments';
import PatientDocuments from './PatientDocuments';
import PatientTreatmentPlans from './PatientTreatmentPlans';

interface PatientTabViewProps {
  patient: Patient & {
    profile?: any;
    documents?: any[];
    appointments?: any[];
    medicalNotes?: any[];
  };
}

const PatientTabView: React.FC<PatientTabViewProps> = ({ patient }) => {
  return (
    <Tabs defaultValue="info" className="mt-6">
      <TabsList className="grid grid-cols-5 mb-4">
        <TabsTrigger value="info">Personal Info</TabsTrigger>
        <TabsTrigger value="medical">Medical Info</TabsTrigger>
        <TabsTrigger value="documents">Documents</TabsTrigger>
        <TabsTrigger value="treatments">Treatment Plans</TabsTrigger>
        <TabsTrigger value="appointments">Appointments</TabsTrigger>
      </TabsList>
      
      <TabsContent value="info">
        <PatientPersonalInfo patient={patient} />
      </TabsContent>
      
      <TabsContent value="medical">
        <PatientMedicalInfo patient={patient} />
      </TabsContent>
      
      <TabsContent value="documents">
        <PatientDocuments patient={patient} />
      </TabsContent>
      
      <TabsContent value="treatments">
        <PatientTreatmentPlans patientId={patient.id} />
      </TabsContent>
      
      <TabsContent value="appointments">
        <PatientAppointments patient={patient} />
      </TabsContent>
    </Tabs>
  );
};

export default PatientTabView;
